import { makeVar } from '@apollo/client';

type loginStatusVar = {
  isLoggedIn: boolean;
  isLogging: boolean;
  forceGetSession: boolean;
  mustFinalizeRegister: boolean;
  isSessionExpired: boolean;
  shouldLogFirst: boolean;
  redirection: string | null;
};

type GreetingVar = {
  firstname: string;
  email: string;
};

export const defaultLoginStatus: loginStatusVar = {
  isLoggedIn: false,
  isLogging: false,
  forceGetSession: false,
  mustFinalizeRegister: false,
  isSessionExpired: false,
  shouldLogFirst: false,
  redirection: null,
};

export const loginStatusVar = makeVar<loginStatusVar>(defaultLoginStatus);
export const languageVar = makeVar('fr');
export const showAppLoaderVar = makeVar(false);
// signup
export const greetingVar = makeVar<GreetingVar | null>(null);
// bookings
export const previewBookingVar = makeVar<string | null>(null);
export const createBookingVar = makeVar<boolean>(false);
export const refetchBookingsVar = makeVar<boolean>(false);
// conversation
export const conversationIdVar = makeVar<string | null>(null);
export const conversationOpenListVar = makeVar<boolean>(false);
export const conversationDialogOpenVar = makeVar<boolean>(false);
// events
export const previewEventVar = makeVar<string | null>(null);
export const refetchEventsVar = makeVar<boolean>(false);
// network
export const networkStatusVar = makeVar({
  isBackendUnreachable: false,
  retryCount: 0,
});
